import React from 'react';
import style from './select.module.scss';

const Select = ({
  onChange,
  selectedValue,
  defaultValue,
  options,
  className,
}) => (
  <div className={`${style.select} ${className}`}>
    <select
      onChange={onChange}
      value={selectedValue}
      className={`${style.dropdown} col-12 col-md-4`}>
      <option value="">{defaultValue}</option>
      {options &&
        options.map((res) => (
          <option key={res} value={res}>
            {res}
          </option>
        ))}
    </select>
  </div>
);

export default Select;
